import { Typography, Box, Button } from '@material-ui/core';
import React, { FC } from 'react';
import { getDate } from '../../helpers/dateHelper';
import "./index.css"

interface Props {
    closeModal: () => void;
    order: any
}

const getCompetitionName = (type: string): string => {
    switch (type) {
        case "FIXED_ODD":
            return "Fixed Odds"
        default:
            return "product deleted"
    }
}

const ViewSpentCredits: FC<Props> = ({ closeModal, order }) => {
    return (
        <>
            {
                order ?
                    <>
                        <Box display="flex" justifyContent="center" padding="2em">
                            <Typography variant="h6" className="base-color">
                                View Credits details
            </Typography>
                        </Box>
                        <Box display="flex" justifyContent="space-between" padding="2em">
                            <Box>
                                <Typography className="base-color" id="font-bold" >
                                    Competition
                    </Typography>
                                <Typography className="base-color">
                                    {order.prizeType}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography className="base-color" id="font-bold" >
                                    Product
                    </Typography>
                                <Typography className="base-color">
                                    {(order.prizeName || "product deleted")}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography className="base-color" id="font-bold" >
                                    Number of tickets
                    </Typography>
                                <Typography className="base-color">
                                    {order.tickets}
                                </Typography>
                            </Box>
                        </Box>
                        <Box display="flex" justifyContent="space-between" padding="2em">
                            <Box>
                                <Typography className="base-color" id="font-bold" >
                                    Start Date
                    </Typography>
                                <Typography className="base-color">
                                    {getDate(new Date(order?.startAt)) || "competition deleted"}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography className="base-color" id="font-bold" >
                                    Finish Date
                    </Typography>
                                <Typography className="base-color">
                                    {getDate(new Date(order?.endsAt)) || "competition deleted"}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography className="base-color" id="font-bold" >
                                    Amount
                    </Typography>
                                <Typography className="base-color">
                                    {order.spentCredits / 100}{" "} credits
                    </Typography>
                            </Box>
                        </Box>
                    </> :
                    <Box display="flex" justifyContent="center" padding="2em">
                        <Typography variant="h6" className="base-color">
                            No Data
                        </Typography>
                    </Box>
            }
            <Box display="flex" justifyContent="space-evenly" paddingTop="2em" >
                <Button className="user-cancel-button user-modal-buttons" onClick={closeModal}>Cancel</Button>
            </Box>
        </>
    )
}

export default ViewSpentCredits